// Согласование числа с существительным (FR-036в): «1 сеанс», «2 сеанса», «5 сеансов».

/** Три формы слова: для 1 (21, 101), для 2–4 (22, 104), для 0 и 5–20 (11–14, 111). */
export type PluralForms = readonly [one: string, few: string, many: string];

export function plural(n: number, forms: PluralForms): string {
  const abs = Math.abs(n);
  // Дробное число: «1,5 сеанса».
  if (!Number.isInteger(abs)) return forms[1];
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
}

/**
 * Число по-русски: разряды через неразрывный пробел с пяти знаков («10 000»),
 * четырёхзначные — слитно («1000»). Не зависит от Intl браузера.
 */
export function formatNumber(n: number): string {
  const sign = n < 0 ? '-' : '';
  const [whole = '', fraction] = String(Math.abs(n)).split('.');
  const grouped = whole.length >= 5 ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : whole;
  return sign + grouped + (fraction === undefined ? '' : `,${fraction}`);
}

/** «2 сеанса», «10 001 запись». */
export function formatCount(n: number, forms: PluralForms): string {
  return `${formatNumber(n)} ${plural(n, forms)}`;
}

/** Слова, которые 001 согласует с числом. */
export const nouns = {
  session: ['сеанс', 'сеанса', 'сеансов'],
  substitution: ['замещение', 'замещения', 'замещений'],
  record: ['запись', 'записи', 'записей'],
  user: ['пользователь', 'пользователя', 'пользователей'],
} as const satisfies Record<string, PluralForms>;
